export default "__VITE_PUBLIC_ASSET__019a8f19__"